module.exports = __webpack_public_path__ + "img/newQilianduo.55199769.png";